export default __webpack_public_path__ + "static/media/rating_3.39bfea2e.png";